import { useQuery } from "@tanstack/react-query";

import { Claim } from "../../api/ClientFileApi";
import { useClaimsApi } from "../../api/ClientFileApiContext";
import { ClientFileQueryKey } from "../../query/clientFileQueryKeys";

/**
 * The one definition of the client-claims query. Every reader of a client's claims — the list, the
 * inactive-participant badge, the bulk surcharge — goes through here, so they share not only the
 * cache entry but its configuration: a `staleTime` or `retry` added once applies to all of them.
 * `select` narrows the data a caller receives without changing what is cached.
 */
export function useClientClaims<TData = Claim[]>(clientId: string | undefined, select?: (claims: Claim[]) => TData) {
  const claimsApi = useClaimsApi();

  return useQuery<Claim[], Error, TData>({
    queryKey: [ClientFileQueryKey.ClientClaims, clientId],
    queryFn: () => {
      if (!clientId) {
        throw new Error("Client ID is required");
      }
      return claimsApi.getClaimsByClientId({ clientId });
    },
    enabled: !!clientId,
    select,
  });
}
